export default {
    routerName: '履歴文章管理',
    article: {
        title: 'タイトル',
        body: '詳細',
        author: '作者',
        releaseTime: 'リリース日付',
        createStartTime: 'リリース開始',
        createEndTime: 'リリース終了',
        disabled: '無効',
        yes: 'はい',
        no: 'いいえ',
        status: '状態',
        statusOption0: '下書き',
        statusOption1: '審査失敗',
        statusOption2: '審査中',
        statusOption9: '審査成功',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        hits: '閲覧量',
    },
    table: {
        id: 'ID',
        title: 'タイトル',
        author: '作者',
        status: '状態',
        disabled: '無効',
        createBy: '作成者',
        releaseTime: 'リリース日付',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        hits: '閲覧量',
    },
};
